module.exports = __webpack_public_path__ + "static/img/feature_2.54ebe8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/feature_2.png
// module id = DOHA
// module chunks = 0